<template>
  <v-btn
    :icon="icon"
    flat
    :disabled="disabled"
    :small="small"
  >
    <v-tooltip top>
      <template #activator>
        <v-icon
          :small="small"
          :icon="icon"
          color="secondary"
        />
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      disabled: Boolean,
      small: Boolean
    }
  }
</script>

